import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'widget',
  templateUrl: './widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryWidgetComponent implements OnInit {
  @Input() data;
  url;
  id;
  urlVideos;
  videos = [];
  currentVideo = 0;
  heading;
  showWidget = true;

  @Output() continueWidgetVideoEmitter: EventEmitter<any> = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.urlVideos = this.data.video_code_list.split(',');
    this.videos = this.urlVideos.map((video) => ({ id: video, url: `wistia_embed wistia_async_${video} playlistLinks=auto itStrategy=contain` }));
    this.heading = JSON.parse(this.data.header);
    this.cd.detectChanges();
  }

  handleSteps(direction: string) {
    if (direction == 'forward') {
      if (this.currentVideo == this.urlVideos.length - 1) {
        // Done emit value
        this.save();
      } else {
        this.currentVideo++;
        this.cd.detectChanges;
      }
    } else {
      if (this.currentVideo == 0) {
        this.back();
      } else {
        this.currentVideo--;
        this.cd.detectChanges();
      }
    }
  }

  save() {
    this.continueWidgetVideoEmitter.emit({ status: 'forward', step: this.data.name, id: this.data.id });
  }

  back() {
    this.continueWidgetVideoEmitter.emit({ status: 'backward', step: this.data.name });
  }
}
